import LinkFeedbackModal from './LinkFeedbackModal';

export default LinkFeedbackModal;
